<template>
  <div class="w-full pa-sm-3">
    <ContentCreator />
  </div>
</template>

<script>
import ContentCreator from '@/modules/contentCreator'

export default {
  components: {
    ContentCreator,
  },
}
</script>
<style scoped>
.content-creator-container {
  width: 100%;
  padding: 12px;
  margin-right: auto;
  margin-left: auto;
}
</style>
